export default function PageHeader({ overline, title, description, action }) {
  return (
    <div className="px-6 lg:px-8 pt-6 lg:pt-8 pb-4 border-b border-border bg-white">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="eos-overline">{overline}</div>
          <h1 className="font-heading font-extrabold text-3xl md:text-4xl tracking-tight mt-1">{title}</h1>
          {description && <p className="text-sm text-muted-foreground mt-1.5 max-w-2xl">{description}</p>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
    </div>
  );
}
